import { Link } from "react-router-dom";
import { ChevronRight, ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import { fmtDate } from "@/lib/format";
import { Panel, SectionLabel, StatusBadge } from "@/components/common/ui-kit";

const BAR = { red: "bg-red-500", amber: "bg-amber-500" };

export const AttentionPanel = ({ items }) => (
  <Panel className="animate-rise delay-2 overflow-hidden" data-testid="dashboard-section-attenzione">
    <div className="flex items-center justify-between border-b border-line px-5 py-4">
      <div>
        <SectionLabel>Attenzione</SectionLabel>
        <h2 className="mt-1 font-display text-lg font-bold text-slate-900" data-no-terms="">Cosa richiede intervento</h2>
      </div>
      {items.length > 0 && <StatusBadge tone="red" data-testid="attention-count">{items.length} elementi</StatusBadge>}
    </div>
    {items.length === 0 ? (
      <div className="flex items-center gap-3 px-5 py-8 text-sm text-slate-500" data-testid="attention-empty">
        <ShieldCheck className="h-5 w-5 text-emerald-500" />Nessuna situazione critica. Ottimo lavoro.
      </div>
    ) : (
      <ul className="divide-y divide-slate-100">
        {items.map((it, i) => (
          <li key={`${it.kind}-${i}`}>
            <Link to={it.path} className="group flex items-center gap-4 px-5 py-3.5 transition-colors hover:bg-slate-50" data-testid={`attention-item-${i}`}>
              <span className={cn("h-9 w-1 shrink-0 rounded-full", BAR[it.tone])} />
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-slate-800">{it.title}</p>
                <p className="truncate text-xs text-slate-500">{it.subtitle}</p>
              </div>
              <div className="hidden shrink-0 flex-col items-end gap-1 sm:flex">
                <StatusBadge tone={it.tone}>{it.label}</StatusBadge>
                {it.date && <span className="text-[11px] text-slate-400">{fmtDate(it.date)}</span>}
              </div>
              <ChevronRight className="h-4 w-4 shrink-0 text-slate-300 transition-transform group-hover:translate-x-0.5" />
            </Link>
          </li>
        ))}
      </ul>
    )}
  </Panel>
);
